import { Link } from "react-router-dom";
import { Zap, Search, Package, ArrowRight, Truck, Clock, Route } from "lucide-react";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { Button } from "@/components/ui/button";
import { BRAND } from "@/lib/brand";

export default function Hotshot() {
  return (
    <PublicLayout>
      <section className="relative min-h-[70vh] flex items-center grain">
        <img src={BRAND.heroDually} alt="XD Freight hotshot dually with gooseneck" className="absolute inset-0 w-full h-full object-cover animate-kenburns" />
        <div className="absolute inset-0 bg-gradient-to-r from-xd-bg via-xd-bg/85 to-xd-bg/20" />
        <div className="relative max-w-7xl mx-auto px-6 w-full">
          <span className="inline-flex items-center gap-2 rounded-full bg-xd-gold/15 border border-xd-gold/30 text-xd-gold px-3 py-1 text-xs font-bold uppercase tracking-wide"><Zap size={13} /> Hotshot Freight</span>
          <h1 className="mt-5 font-heading text-5xl sm:text-6xl font-black tracking-tighter max-w-2xl">Hotshot is one of our specialties.</h1>
          <p className="mt-5 text-lg text-xd-muted max-w-xl">XD Freight understands the speed, flexibility, equipment, and operational demands of hotshot and expedited transportation — gooseneck, bumper pull, and 1-ton diesel freight.</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <Button asChild data-testid="hotshot-find-btn" className="h-13 min-h-[54px] px-8 bg-xd-blue hover:bg-xd-blueH text-white font-bold rounded-xl"><Link to="/find-loads"><Search size={18} className="mr-2" /> Find Hotshot Loads</Link></Button>
            <Button asChild data-testid="hotshot-ship-btn" variant="outline" className="h-13 min-h-[54px] px-8 border-white/25 bg-white/5 text-white hover:bg-white/10 font-bold rounded-xl"><Link to="/ship"><Package size={18} className="mr-2" /> Ship Hotshot Freight</Link></Button>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-24 grid gap-6 md:grid-cols-3">
        <Card icon={Zap} title="Expedited & urgent" desc="Time-critical freight moved fast with dedicated hotshot capacity." />
        <Card icon={Truck} title="The right equipment" desc="Gooseneck, bumper pull, flatbed and 1-ton diesel trucks matched to your load." />
        <Card icon={Route} title="Regional & long-haul" desc="Houston, Texas triangle, oilfield lanes and beyond." />
      </section>

      <section className="border-t border-xd-border bg-xd-paper">
        <div className="max-w-7xl mx-auto px-6 py-20 text-center">
          <h2 className="font-heading text-4xl font-bold tracking-tight">Move hotshot with XD</h2>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild className="h-12 px-8 bg-xd-blue hover:bg-xd-blueH text-white font-bold rounded-xl"><Link to="/find-loads">Find Hotshot Loads</Link></Button>
            <Button asChild className="h-12 px-8 bg-xd-gold hover:bg-xd-goldH text-xd-bg font-bold rounded-xl"><Link to="/register">Join XD <ArrowRight size={16} className="ml-2" /></Link></Button>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}

function Card({ icon: Icon, title, desc }) {
  return (
    <div className="bg-xd-paper border border-xd-border rounded-xl p-6 hover:border-xd-gold/50 transition-colors">
      <span className="grid place-items-center w-12 h-12 rounded-xl bg-xd-gold/15 text-xd-gold"><Icon size={24} /></span>
      <h3 className="mt-4 font-heading text-xl font-bold">{title}</h3>
      <p className="mt-2 text-sm text-xd-muted">{desc}</p>
    </div>
  );
}
